import { User } from "../types/types";

export function retrieveDisplayNameForUser(user: Partial<User>) {
    if (!user) {
        return '';
    }
    return user.firstName ? (user.lastName ? user.firstName + ' ' + user.lastName : user.firstName) : (user.lastName ? user.lastName : (user.email ? user.email : ''));
}